// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"310cbfbe","63":"82bcb82f","112":"9b7e7e8f","134":"32686f88","617":"1a07125c"}[chunkId] + ".chunk.js";
};